export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || (navigator as any).vendor || (window as any).opera;
  const uaDataMobile = (navigator as any).userAgentData?.mobile ?? false;

  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isGenericMobile = /Mobile|Tablet|Phone|Android|iPad|iPhone/i.test(ua);

  return Boolean(uaDataMobile || isAndroid || isIOS || isGenericMobile);
};

export const isIOS = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || (navigator as any).vendor || (window as any).opera;
  return /iPhone|iPad|iPod/i.test(ua);
};
